import {
  SET_DIALOG_GRANT_DOOR_ACCESS_USER_IDS,
  CLEAR_DIALOG_GRANT_DOOR_ACCESS_USER_IDS,
  LOGOUT_RESPONSE,
} from '../constants'

const initialState = []

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_DIALOG_GRANT_DOOR_ACCESS_USER_IDS:
      return action.accessIds

    case CLEAR_DIALOG_GRANT_DOOR_ACCESS_USER_IDS:
    case LOGOUT_RESPONSE:
      return initialState

    default:
      return state
  }
}
